import { render } from "./EmployeeApprovalsNew.vue?vue&type=template&id=d3b7c728&scoped=true"
import script from "./EmployeeApprovalsNew.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovalsNew.vue?vue&type=script&lang=js"

import "./EmployeeApprovalsNew.vue?vue&type=style&index=0&id=d3b7c728&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3b7c728"]])

export default __exports__